import { handleReferences } from './formatReferenceToSelect'

export const toContentState = ({ type, reference, data: originalData = {} }) => {
  const data = handleReferences(originalData)

  switch (type) {
    case 'curso':
      return {
        tituloCurso: data.titulo || '',
        autoresCurso: data.autores,
        codigoProtheus: data.codigo,
        copyrightCurso: data.copyright,
        edicaoCurso: data.edicao,
        especialidadesCurso: data.especialidades,
        cursoReferencia: reference
      }

    case 'livro':
      return {
        tituloLivro: data.titulo || '',
        autoresLivro: data.autores,
        isbn: data.isbn,
        codigoProtheus: data.codigo,
        copyrightLivro: data.copyright,
        edicaoLivro: data.edicao,
        especialidadesLivro: data.especialidades,
        livroReferencia: reference,
        origemId: ''
      }

    case 'capitulo':
      return {
        tituloCapitulo: data.titulo || '',
        codigoCapitulo: data.codigo,
        tituloLivro: data.tituloLivro || '',
        autoresLivro: data.autoresLivro,
        isbn: data.isbn,
        codigoProtheus: data.codigoProtheus,
        copyrightLivro: data.copyrightLivro || '',
        edicaoLivro: data.edicaoLivro,
        especialidadesLivro: data.especialidadesLivro,
        tituloSecao: data.tituloSecao || '',
        autoresSecao: data.autoresSecao,
        textoSecao: data.textoSecao || '',
        origemId: reference,
        livroReferencia: data.livroReferencia
      }

    case 'artigo':
      return {
        tituloArtigo: data.titulo || '',
        codigoArtigo: data.codigo,
        tituloLivro: data.tituloLivro || '',
        autoresArtigo: data.autores,
        editoresArtigo: data.editores,
        codigoProtheus: data.codigoProtheus,
        edicaoLivro: data.edicaoLivro,
        especialidadesLivro: data.especialidadesLivro,
        origemId: reference,
        anoPublicacaoArtigo: data.anoPublicacao || '',
        dataAtualizacao: data.dataAtualizacao || ''
      }

    case 'diagnostico_e_tratamento':
      return {
        tituloDeT: data.titulo || '',
        codigoDeT: data.codigo,
        tituloLivro: data.tituloLivro || '',
        autoresDeT: data.autores,
        editoresDeT: data.editores,
        codigoProtheus: data.codigoProtheus,
        edicaoLivro: data.edicaoLivro,
        especialidadesLivro: data.especialidadesLivro,
        origemId: reference,
        anoPublicacaoDeT: data.anoPublicacao || '',
        dataAtualizacao: data.dataAtualizacao || ''
      }
    default:
      return {}
  }
}



// WEBPACK FOOTER //
// ./src/utils/handlePreRegistrationApiData.js